import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import { InputField } from "../../Shared/InputField"

const ComplaintCategoryForm = () => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({ name: '' })
    const { name } = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        addCategory({ name })
    }

    const addCategory = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/complaint-categories/', payload)
            toast.success(response.data.detail || 'Successfully created')
            navigate('/complaint-categories/')
        } catch (error) {
            if (error.response?.status === 401) {
                navigate('/login')
            } else if (error.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map(err =>
                    setErrors(prev => ({ ...prev, [err.loc[1]]: err.msg }))
                )
            } else if (error.response?.status === 403) {
                toast.error(error.response.data.detail);
                navigate('/');
            } else {
                toast.error(error.response?.data?.detail || 'Failed to create category');
            }
        } finally {
            setIsLoading(false)
        }
    }

    if (isLoading) return <Spinner/>

    return (
        <>
            <div className="card">
                <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">Create Complaint Category</h3>
                </div>
                <div className="card-body">
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-md-8">
                                <InputField
                                    placeholder="Category Name"
                                    name="name"
                                    type="text"
                                    label="Name"
                                    value={name}
                                    onChange={onChange}
                                    error={errors.name}
                                />
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-12">
                                <input type="submit" className="btn btn-outline-info" value="Save Category" style={{float: 'right'}}/>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <br/>
        </>
    )
}

export default ComplaintCategoryForm
